import background from '../../assets/pictures/background-login.jpg';
export const styles = theme => ({
  root: {
    height: '100vh'
  },
  image: {
    backgroundImage: `url(${background})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  },
  paper: {
    marginTop: theme.spacing.unit * 8,
    marginRight: theme.spacing.unit * 4,
    marginLeft: theme.spacing.unit * 4,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  avatar: {
    width: theme.spacing.unit * 12,
    height: theme.spacing.unit * 12
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing.unit
  },
  submit: {
    marginTop: theme.spacing.unit * 2
  },
  link: {
    textDecoration: 'underline',
    color: '#009973', 
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
      color: '#009973', 
    }
  }
});